import React from "react";
import { CheckboxEditor } from "../../../../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../../../../../react-core/Html/SelectEditor";
import { JsonDateParser } from "../../../../../../../../../react-core/Utils/JsonDateParser";
import { ServiceProposition } from "../../../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { UserClaim } from "../../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { MailingPreferenceHistory } from "../../../../../../../../../Wrap/Models/Domains/Account/MailingPreferenceHistory";
import { MailingPreferenceHistoryCollection } from "../../../../../../../../../Wrap/Models/Domains/Account/MailingPreferenceHistoryCollection";
import { ClientAccount } from "../../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { checkPermission } from "../../../../../../../../Shared/Permission/PermissionHelper";
import { Table } from "../../../../../../../../Shared/Table/Table";
import { ClientAccountStore } from "../../../../../../../Stroes/Variable";
import { AccountInfoAction } from "../../Action/AccountInfoAction";
import { portfolioDashboardRolesAction } from "../../Action/Action";

interface IPaperlessPerferenceProps {
    accountHierarchyId: string;
    customerId: number;
}

interface IPaperlessPerferenceState {
    clientAccount: ClientAccount;
    isEdit: boolean;
    termsConfirmed: boolean;
    paperless: boolean;
    history: MailingPreferenceHistoryCollection;
    curPage: number;
}

export class PaperlessPerference extends FormComponent<IPaperlessPerferenceProps, IPaperlessPerferenceState> {
    constructor(props: IPaperlessPerferenceProps) {
        super(props);
        this.state = {
            clientAccount: null,
            isEdit: false,
            termsConfirmed: false,
            paperless: null,
            history: null,
            curPage: 1,
        };
        this.subscribeToStore(ClientAccountStore, () => this.onStoreChange());
    }

    private onStoreChange() {
        const data = ClientAccountStore.getClientAccountInfo();

        this.setState(
            {
                clientAccount: data,
                paperless: data?.GoPaperless,
                termsConfirmed: data?.GoPaperless == true,
            },
            () => {
                this.getData(1, 10);
            }
        );
    }

    getData(minrow: number, maxrow: number) {
        AccountInfoAction.getPaperlessChangeHistory(this.state.clientAccount?.HierarchyId, minrow, maxrow, (result) => {
            this.setState({ history: result });
        });
    }

    private saveData() {
        if (this.isValid()) {
            this.state.clientAccount.GoPaperless = this.state.paperless;
            this.setState({ paperless: null, isEdit: false, clientAccount: this.state.clientAccount });
            portfolioDashboardRolesAction.updateClientAccountDetails(this.state.clientAccount, null, null, () => {
                this.getData(1, 10);
            });
        }
    }

    render() {
        const { clientAccount, isEdit } = this.state;
        if (!clientAccount) {
            return (
                <>
                    <h4>Paperless Preference</h4>
                    <PartLoading isLoading={true} />
                </>
            );
        }

        const canEditPaperlessPermission = checkPermission(UserClaim.AdviserPortalAccountPaperlessReadWrite);
        const canEditPaperlessCompany = ![
            "NonAdvisedCOMP",
            "ORPHANCOMP",
            "SAVINGSDIRECT",
            "SLIFEDIRECT",
            "RBSG",
        ].includes(this.state.clientAccount?.Company);
        const canEditPaperlessServiceProposition = [
            ServiceProposition.Fundzone,
            ServiceProposition.Wrap,
            ServiceProposition.NonWrapEnabled,
        ].includes(this.state.clientAccount?.AccountServicePropositionId);
        const canEditPaperlessOption =
            canEditPaperlessCompany && canEditPaperlessPermission && canEditPaperlessServiceProposition;
        return (
            <>
                <h4>Paperless Preference</h4>
                {!isEdit && (
                    <>
                        <dl className="def-list">
                            <dt>Go paperless option</dt>
                            <dd>{clientAccount.GoPaperless && canEditPaperlessOption ? "Yes" : "No"}</dd>
                        </dl>
                        {canEditPaperlessOption && (
                            <div className="row row-center">
                                <div className="col-auto">
                                    <button
                                        className="edit-circle-icon-button label-sr-only"
                                        title="Edit"
                                        onClick={(val) => this.setState({ isEdit: true })}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                        <span className="text">Edit</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                )}
                {isEdit && (
                    <>
                        <p>
                            Please note that there are certain documents which for legal or regulatory reasons must
                            still be sent directly to the customer. For details of which documents we are referring to
                            please see our Adviser website. Please note that all documents can be accessed from the
                            client’s Document Library
                        </p>
                        <SelectEditor
                            getText={(v) => {
                                return v ? "Yes" : "No";
                            }}
                            selected={clientAccount.GoPaperless}
                            onChange={(v) => {
                                this.setState({ paperless: v });
                            }}
                            label="Go Paperless"
                            options={[true, false]}
                            cssWrapper={"control-size-245"}
                        />
                        {this.state.paperless && (
                            <CheckboxEditor
                                required={"You must tick the declaration checkbox when selecting Yes to Go Paperless"}
                                label="I confirm I have received instruction from my client(s) to manage their correspondence on their behalf and will ensure that this information is passed onto my client(s). I am able to provide evidence of my client(s) instruction on abrdn request"
                                cssWrapper="control-size-60 square-checkbox"
                                onChange={(v) => {
                                    this.setState({ termsConfirmed: v });
                                }}
                                value={this.state.termsConfirmed}
                            />
                        )}
                        <div className="row row-center">
                            <div className="col-auto">
                                <button
                                    className="button mr-20"
                                    onClick={() => {
                                        this.setState({
                                            isEdit: false,
                                        });
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="col-auto">
                                <button className="button" onClick={(val) => this.saveData()}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </>
                )}
                <h3>Change History</h3>
                <Table
                    data={this.state.history?.Result}
                    col={[
                        { title: "Name", key: "Name" },
                        { title: "UserId", key: "UserId" },
                        {
                            title: "New Value",
                            key: "NewValue",
                            render: (data, row: MailingPreferenceHistory) => {
                                return row?.NewValue ? "Yes" : "No";
                            },
                        },
                        {
                            title: "Date",
                            key: "Name",
                            render: (data, row: MailingPreferenceHistory) => {
                                return JsonDateParser.getFormatDate(row?.Date, "dd/MM/yyyy hh:mm:ss");
                            },
                        },
                        {
                            title: "Change Level",
                            key: "ChangeLevel",
                            render: (data, row: MailingPreferenceHistory) => {
                                return row?.ChangeLevel ? "Adviser" : "Individual";
                            },
                        },
                    ]}
                    isLoading={this.state.history == null}
                    needPagination={{
                        totalNumOfResult: this.state.history?.TotalNumberOfResults,
                        onPaginationChange: (pageIndex, pageSize) => {
                            this.setState({ curPage: pageIndex });
                            this.getData(pageIndex * pageSize + 1, pageSize * (pageIndex + 1));
                        },
                        pageSize: 10,
                        currentPage: this.state.curPage,
                    }}
                />
            </>
        );
    }
}
